module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "nurse_func"
  }, [_c('p', [_vm._v("Данный функционал будет добавлен в проект в ближайшее время.")]), _vm._v(" "), _c('p', [_vm._v("Следите за обновлениями проекта.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c7127a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cabinet/Message/Message.vue
// module id = 590
// module chunks = 0